import React, { useEffect, useState } from 'react';
import { isValidPhoneNumber } from 'react-phone-number-input';
import { ButtonComponent, InputField, PhoneNumberInput } from '../component/Common';
import '../style/login.css';
import Swal from "sweetalert2";
import { useNavigate, useLocation } from "react-router-dom";
import api from "../utils/api";

const Staff = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const [staffLogin, setStaffLogin] = useState({
        mobileNo: '',
        otp: '',
    });

    const [errors, setErrors] = useState({});
    const [isOtpRequested, setIsOtpRequested] = useState(false);
    const [isInitialLoad, setIsInitialLoad] = useState(true);

    useEffect(() => {
        setIsInitialLoad(false);
    }, []);

    useEffect(() => {
        if (!isInitialLoad) {
            checkToken();
        }
    }, [isInitialLoad]);

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        if (queryParams.get("logout") === "success") {
            Swal.fire({
                icon: "success",
                iconColor: '#008000',
                title: "You have been logged out successfully.",
                showConfirmButton: false,
                timer: 3000,
            });

            queryParams.delete("logout");
            const newUrl = queryParams.toString() ? `${location.pathname}?${queryParams.toString()}` : location.pathname;
            window.history.replaceState({}, document.title, newUrl);
        }
    }, [location.search]);

    const checkToken = async () => {
        const token = localStorage.getItem('userToken');
        if (!token) {
            return;
        }
        try {
            const result = await api.get('/verify_user_token');
            if (result.status === 200) {
                navigate('/mga-staff-portal/dashboard');
            }
        } catch (error) {
            localStorage.removeItem('userToken');
        }
    };

    const updateErrorMessages = () => {
        for (const key in errors) {
            const errorMessageElement = document.getElementById(`error-message-${key}`);
            const input = document.getElementById(key);
            if (errorMessageElement) {
                errorMessageElement.textContent = errors[key];
                if (input) {
                    if (errors[key] === '') {
                        input.style.setProperty('border', '1px solid #ccc', 'important');
                        input.style.setProperty('border-radius', '4px', 'important');
                    } else {
                        input.style.setProperty('border', '1px solid red', 'important');
                        input.style.setProperty('border-radius', '4px', 'important');
                    }
                }
            }
        }
    };

    useEffect(updateErrorMessages, [errors]);

    const handlePhoneNumber = (value, name) => {
        setStaffLogin((prevData) => ({ ...prevData, [name]: value || "" }));
        setErrors((prevData) => ({ ...prevData, [name]: "" }));
    };

    const handleInputChange = (e) => {
        const { id, value } = e.target;
        setStaffLogin((prevData) => ({ ...prevData, [id]: value || "" }));
        setErrors((prevData) => {
            const newErrors = { ...prevData };
            delete newErrors[id];
            return newErrors;
        });
    };

    const handleGetOtpClick = async () => {
        if (!isValidPhoneNumber(staffLogin.mobileNo)) {
            setErrors({ mobileNo: "Enter a valid mobile number." });
            return;
        }
        try {
            const result = await api.post('/staff-login-otp', {
                phone: staffLogin.mobileNo
            });
            if (result.status == 200) {
                setIsOtpRequested(true);
                setErrors({});
            }
        } catch (error) {
            console.error('Error sending OTP:', error);
            if (error.response.status == 404) {
                Swal.fire({
                    icon: "error",
                    iconColor: '#AB1717',
                    title: error.response.data.message,
                    showConfirmButton: false,
                    timer: 3000,
                });
            }
        }
    };

    const handleFormSubmission = async () => {
        if (!staffLogin.otp) {
            setErrors({ otp: "OTP is required." });
            return;
        }
        try {
            const result = await api.post('/verify-otp', {
                phone: staffLogin.mobileNo,
                otp: staffLogin.otp
            });
            if (result.status === 200 && (result.data.userType == "admin" || result.data.userType == "staff")) {
                localStorage.setItem('userToken', result.data.userToken);
                localStorage.setItem('userType', result.data.userType);
                setIsOtpRequested(true);
                setErrors({});
                navigate('/mga-staff-portal/dashboard');
            }
        } catch (error) {
            console.error('Error verifying OTP:', error);
            setErrors({ otp: 'Failed to verify OTP. Please try again.' });
        }
    };

    const handleKeyPress = (e) => {
        if (e.key === "Enter") {
            if (!isOtpRequested) {
                handleGetOtpClick();
            } else {
                handleFormSubmission();
            }
        }
    };

    return (
        <>
            <div className="home_container">
                <main className="main-content">
                    <div className="login_form" onKeyDown={handleKeyPress}>
                        <div className="form_name">Staff Login</div><br />
                        <PhoneNumberInput
                            label="Enter Mobile No:"
                            htmlFor="mobileNo"
                            placeholder="Enter your mobile number"
                            value={staffLogin.mobileNo || ""}
                            onChange={(value) => handlePhoneNumber(value, 'mobileNo')}
                            disabled={isOtpRequested}
                        />
                        <p id="error-message-mobileNo" className="error_message"></p>

                        {!isOtpRequested ? (
                            <ButtonComponent label="Continue" name="Continue" onClick={handleGetOtpClick} />
                        ) : (
                            <>
                                <InputField
                                    label="Enter OTP:"
                                    type="number"
                                    htmlFor="otp"
                                    value={staffLogin.otp || ""}
                                    placeholder="Enter your OTP"
                                    onChange={handleInputChange}
                                />
                                <p id="error-message-otp" className="error_message"></p>
                                <ButtonComponent label="Verify OTP" name="Verify OTP" onClick={handleFormSubmission} />
                            </>
                        )}
                    </div>
                </main>
            </div>
        </>
    )
}

export default Staff;